import { MessageBox, ChatItem, SystemMessage, MessageList, Input, Button } from 'react-chat-elements';
import { Comment, Header, GridColumn, Grid, Dimmer, Loader, Label, Icon } from 'semantic-ui-react'
import React, { useState, useEffect, useRef } from 'react'

import './ChatSnippets.less'


const ChatSnippets = ({ onSnippetSelect  , chatCnippetsData}) => {

    const snippetSelectHandler = (snippetText) => {
        onSnippetSelect(snippetText);
    }

    return (
        <div className={"snippets-container"}>
            {
                chatCnippetsData ? chatCnippetsData.map((snippet, index) => {
                    return (
                        <>
                            <div id={`blue-bot`} className={`blue-dot-container`} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                    <g id="Group_13425" data-name="Group 13425" transform="translate(-18 -700)">
                                        <circle id="Ellipse_355" data-name="Ellipse 355" cx="7.5" cy="7.5" r="7.5" transform="translate(18 700)" fill="#ebfffe" />
                                        <circle id="Ellipse_356" data-name="Ellipse 356" cx="3.5" cy="3.5" r="3.5" transform="translate(22 704)" fill="#03d6cb" />
                                    </g>
                                </svg>
                            </div>
                            <div onClick={() => { snippetSelectHandler(snippet) }} className={"snippet-container"}>
                                <div className={"snippet-inner-container"}>
                                    <p className={"snippet-text"}>
                                        {snippet}
                                    </p>
                                </div>       
                            </div>
                        </>
                    )
                })
                : 
                <h1> {"No snippets available"} </h1> 
            }
        </div>
    )
}

export default ChatSnippets;
